// extracted by mini-css-extract-plugin
export default {"container":"GUS5nb78TJ","pagination":"D2CzELeXPa","pagination-cell":"iVMStxz7PW","paginationCell":"iVMStxz7PW"};
    if(module.hot) {
      // 1650538051485
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  